<template>
  <b-modal
      ref="modal"
      id="reject-application-modal"
      title="Please confirm"
      centered
      ok-title="Confirm"
      ok-variant="success"
      @ok="confirmReject"
  >
    <h4>You are going to reject this application</h4>
    <hr>
    <b-form-group label="Reason of Rejection">
      <b-form-textarea
        v-model="formData.reason"
        rows="6"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "AdminApplicationRejectModal",
  emits: ['confirm'],
  data() {
    return {
      formData: {
        reason: ""
      }
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'reject-application-modal');
    },
    confirmReject() {
      this.$emit('confirm', this.formData);
    }
  }
}
</script>
